import React from "react";
import { ConfirmationModal } from "@folio/stripes/components";
import { useIntl } from "react-intl";
var WarningModal = function (_a) {
    var open = _a.open, mode = _a.mode, message = _a.message, onConfirm = _a.onConfirm, onCancel = _a.onCancel, confirmLabelOverride = _a.confirmLabel;
    var formatMessage = useIntl().formatMessage;
    var heading = mode === "reload"
        ? formatMessage({ id: "ui-br-publishers.error.modal.title" })
        : formatMessage({ id: "ui-br-publishers.warning.modal.title" });
    var confirmLabel = confirmLabelOverride !== null && confirmLabelOverride !== void 0 ? confirmLabelOverride : (mode === "reload"
        ? formatMessage({ id: "ui-br-publishers.button.refresh" })
        : formatMessage({ id: "ui-br-publishers.button.continue" }));
    var cancelLabel = formatMessage({ id: "ui-br-publishers.button.close" });
    return (React.createElement(ConfirmationModal, { open: open, heading: heading, message: message, confirmLabel: confirmLabel, cancelLabel: cancelLabel, buttonStyle: "primary", onConfirm: onConfirm, onCancel: onCancel }));
};
export default WarningModal;
